<template>
  <div id="root" v-cloak>
    <keep-alive>
      <component :is="layout"></component>
    </keep-alive>
  </div>
</template>

<script>
import layouts from '@/layouts'
import { routeHasChanged } from '@/utilities/router'

export default {
  components: { ...layouts },
  computed: {
    layout() {
      // check for api root env variable - if missing, disable app by loading disabled layout
      if (!this.$env?.API_ROOT_URL) return 'disabled-layout'
      else return this.$store.getters['core/layout'] || 'default-layout'
    },
  },
  watch: {
    $route(to, from) {
      if (routeHasChanged(to, from)) this.$store.dispatch('core/onRouteChange', { from, to })
    },
  },
  created() {
    this.$store.dispatch('core/onInitialLoad', {
      initialStateData: window.initialStateData || {},
    })
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
</style>
